import React from 'react'
import { Users, Lightbulb, GitBranch, Settings } from 'lucide-react'
import { useLocalization } from '../../hooks/useLocalization'

/**
 * Partner Collaboration Section Component
 * 
 * Explains how partners collaborate with the development team
 */
const PartnerCollaborationSection: React.FC = () => {
  const { t } = useLocalization()

  const collaborationPoints = [
    {
      icon: Lightbulb,
      iconColor: 'text-green-600',
      bgColor: 'bg-green-100 dark:bg-green-900',
      key: 'requestFeatures'
    },
    {
      icon: Settings,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-100 dark:bg-blue-900',
      key: 'influenceWorkflows'
    },
    {
      icon: GitBranch,
      iconColor: 'text-purple-600',
      bgColor: 'bg-purple-100 dark:bg-purple-900',
      key: 'guideRoadmap'
    },
    {
      icon: Users,
      iconColor: 'text-indigo-600',
      bgColor: 'bg-indigo-100 dark:bg-indigo-900',
      key: 'continuousCollaboration'
    }
  ]

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            {t('home.partnership.collaboration.title')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {t('home.partnership.collaboration.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {collaborationPoints.map((point) => {
            const Icon = point.icon
            return (
              <div
                key={point.key}
                className="bg-white dark:bg-gray-700 rounded-lg p-6 border border-gray-200 dark:border-gray-600"
              >
                <div className={`w-12 h-12 ${point.bgColor} rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className={`w-6 h-6 ${point.iconColor}`} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {t(`home.partnership.collaboration.${point.key}.title`)}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {t(`home.partnership.collaboration.${point.key}.description`)}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default PartnerCollaborationSection
